export default "__VITE_ASSET__8a33c3d2__"